/**
 *
 * @author arman
 * @since 7/14/17
 *
 */
import React from 'react';
import utils from '../../utility/utils';
import BoxHeader from '../shared/box-header.component';

const styles = {
  root: {

  },
  table: {
    width: '100%'
  },
  th: {
    fontSize: '15px',
    textAlign: 'left',
  },
  tr: {

  },
  td: {
    paddingTop: '10px',
    paddingBottom: '10px',
    textAlign: 'left',
    borderBottom: '1px solid #ddd'
  }
};

const FollowUpInfo = ({ mission, className, style }) => (
  <div className={className} style={{...styles.root, ...style.root}}>
    <BoxHeader title='Follow-up Report(s)' style={style.header} />
    <div style={style.box}>
      <table style={styles.table}>
        <tbody>
        <tr style={styles.th}>
          <th>Follow-up At</th>
          <th>Follow-up By</th>
          <th colSpan="2">Advice</th>
          <th colSpan="2">Comments</th>
        </tr>
        {
          mission.followups
            .map((followup, index) => (
              <tr key={index} style={styles.tr}>
                <td style={styles.td}>{utils.toAppDate(followup.followup_at)}</td>
                <td style={styles.td}>{followup.operator ? followup.operator.name : 'N/A'}</td>
                <td style={styles.td} colSpan="2">{followup.advice || 'N/A'}</td>
                <td style={styles.td} colSpan="2">{followup.comments || 'N/A'}</td>
              </tr>
            ))
        }
        </tbody>
      </table>
    </div>
  </div>
);

export default FollowUpInfo;


// WEBPACK FOOTER //
// ./src/screens/mission-view/followup-info.component.js